import React from 'react';
import { 
  Bot, 
  Sparkles, 
  Brain, 
  Wand, 
  WandSparkles, 
  Zap, 
  Lightbulb, 
  Target, 
  MessageSquare,
  BotMessageSquare,
  BrainCircuit,
  BrainCog
} from 'lucide-react';

const AIIconPreview = () => {
  const aiIcons = [
    { name: 'Bot', component: Bot, description: 'General AI, robots, automation' },
    { name: 'Sparkles', component: Sparkles, description: 'AI magic, smart features' },
    { name: 'Brain', component: Brain, description: 'Intelligence, smart thinking' },
    { name: 'Wand', component: Wand, description: 'AI magic, transformations' },
    { name: 'WandSparkles', component: WandSparkles, description: 'AI magic with sparkles' },
    { name: 'Zap', component: Zap, description: 'AI speed, instant intelligence' },
    { name: 'Lightbulb', component: Lightbulb, description: 'AI insights, smart ideas' },
    { name: 'Target', component: Target, description: 'AI precision, smart matching' },
    { name: 'MessageSquare', component: MessageSquare, description: 'AI chat, conversations' },
    { name: 'BotMessageSquare', component: BotMessageSquare, description: 'AI chatbot, assistant chat' },
    { name: 'BrainCircuit', component: BrainCircuit, description: 'AI neural networks, circuits' },
    { name: 'BrainCog', component: BrainCog, description: 'AI processing, cognitive computing' }
  ];

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">🤖 AI Icons Preview</h2>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {aiIcons.map(({ name, component: IconComponent, description }) => (
          <div key={name} className="flex flex-col items-center p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
            <IconComponent className="w-8 h-8 text-blue-600 mb-2" />
            <h3 className="font-semibold text-gray-900 mb-1">{name}</h3>
            <p className="text-xs text-gray-600 text-center">{description}</p>
            <code className="text-xs bg-gray-100 px-2 py-1 rounded mt-2 font-mono">
              {`<${name} />`}
            </code>
          </div>
        ))}
      </div>
      
      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
        <h3 className="font-semibold text-blue-900 mb-2">🎯 Best for AI Camp Assistant:</h3>
        <div className="flex items-center gap-4">
          <Bot className="w-6 h-6 text-blue-600" />
          <span className="text-blue-800">Main AI assistant button</span>
        </div>
        <div className="flex items-center gap-4 mt-2">
          <MessageSquare className="w-6 h-6 text-green-600" />
          <span className="text-green-800">Chat/conversation features</span>
        </div>
        <div className="flex items-center gap-4 mt-2">
          <Sparkles className="w-6 h-6 text-brand-600" />
          <span className="text-brand-800">AI-powered suggestions</span>
        </div>
      </div>
    </div>
  );
};

export default AIIconPreview;
